import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faMarkdown } from "@fortawesome/free-brands-svg-icons";
import { faChevronDown, faChevronUp, faClone, faEraser, faMagnet, faMousePointer, faObjectGroup, faPen, faTimes, faTrash, } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useMagicKeys, whenever } from "@vueuse/core";
import { BButton, BButtonGroup, BFormInput } from "bootstrap-vue";
//@ts-ignore deprecated package without types (vue 2, remove this comment on vue 3 migration)
import { BoxSelect } from "lucide-vue";
import { storeToRefs } from "pinia";
import { computed, toRefs, watch } from "vue";
import { RemoveAllFreehandCommentsAction } from "@/components/Workflow/Editor/Actions/commentActions";
import { useUid } from "@/composables/utils/uid";
import { useWorkflowStores } from "@/composables/workflowStores";
import { match } from "@/utils/utils";
import { useSelectionOperations } from "./useSelectionOperations";
import { useToolLogic } from "./useToolLogic";
import ColorSelector from "@/components/Workflow/Editor/Comments/ColorSelector.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolBar',
    setup(__props) {
        library.add(faMarkdown, faChevronDown, faChevronUp, faClone, faEraser, faMagnet, faMousePointer, faObjectGroup, faPen, faTimes, faTrash);
        const { toolbarStore, undoRedoStore, commentStore } = useWorkflowStores();
        const { snapActive, currentTool } = toRefs(toolbarStore);
        const { commentOptions } = toolbarStore;
        const { toolbarVisible } = storeToRefs(toolbarStore);
        const snapButtonTitle = computed(() => {
            if (snapActive.value) {
                return "Deactivate snapping (Ctrl + 2)";
            }
            else {
                return "Activate snapping (Ctrl + 2)";
            }
        });
        function onClickPointer() {
            currentTool.value = "pointer";
        }
        function onClickBoxSelect() {
            toolbarStore.boxSelectMode = "add";
            currentTool.value = "boxSelect";
        }
        function onCommentToolClick(comment) {
            currentTool.value = comment;
        }
        watch(() => toolbarStore.currentTool, (currentTool) => {
            if (currentTool === "pointer") {
                toolbarStore.inputCatcherActive = false;
            }
            else {
                toolbarStore.inputCatcherActive = true;
            }
        });
        const snappingDistanceId = useUid("snapping-distance-");
        const snappingDistanceRangeValue = computed({
            get() {
                return match(toolbarStore.snapDistance, {
                    10: () => "1",
                    20: () => "2",
                    50: () => "3",
                    100: () => "4",
                    200: () => "5",
                });
            },
            set(value) {
                toolbarStore.snapDistance = match(parseInt(value), {
                    1: () => 10,
                    2: () => 20,
                    3: () => 50,
                    4: () => 100,
                    5: () => 200,
                });
            },
        });
        const fontSizeId = useUid("font-size-");
        const fontSize = computed({
            get() {
                return `${commentOptions.textSize}`;
            },
            set(value) {
                commentOptions.textSize = parseInt(value);
            },
        });
        const thicknessId = useUid("thickness-");
        const smoothingId = useUid("smoothing-");
        function onRemoveAllFreehand() {
            undoRedoStore.applyAction(new RemoveAllFreehandCommentsAction(commentStore));
        }
        useToolLogic();
        const { ctrl_1, ctrl_2, ctrl_3, ctrl_4, ctrl_5, ctrl_6, ctrl_7, ctrl_8 } = useMagicKeys();
        whenever(ctrl_1, () => (toolbarStore.currentTool = "pointer"));
        whenever(ctrl_2, () => (toolbarStore.snapActive = !toolbarStore.snapActive));
        whenever(ctrl_3, () => (toolbarStore.currentTool = "textComment"));
        whenever(ctrl_4, () => (toolbarStore.currentTool = "markdownComment"));
        whenever(ctrl_5, () => (toolbarStore.currentTool = "frameComment"));
        whenever(ctrl_6, () => (toolbarStore.currentTool = "freehandComment"));
        whenever(ctrl_7, () => (toolbarStore.currentTool = "freehandEraser"));
        whenever(ctrl_8, () => (toolbarStore.currentTool = "boxSelect"));
        const toggleVisibilityButtonTitle = computed(() => {
            if (toolbarVisible.value) {
                return "hide Toolbar";
            }
            else {
                return "show Toolbar";
            }
        });
        const { anySelected, selectedCountText, deleteSelection, deselectAll, duplicateSelection } = useSelectionOperations();
        return { __sfc: true, toolbarStore, undoRedoStore, commentStore, snapActive, currentTool, commentOptions, toolbarVisible, snapButtonTitle, onClickPointer, onClickBoxSelect, onCommentToolClick, snappingDistanceId, snappingDistanceRangeValue, fontSizeId, fontSize, thicknessId, smoothingId, onRemoveAllFreehand, ctrl_1, ctrl_2, ctrl_3, ctrl_4, ctrl_5, ctrl_6, ctrl_7, ctrl_8, toggleVisibilityButtonTitle, anySelected, selectedCountText, deleteSelection, deselectAll, duplicateSelection, FontAwesomeIcon, BButton, BButtonGroup, BFormInput, BoxSelect, ColorSelector };
    }
});
